import { MOCK_PLUGIN_ID_PREFIX } from '../consts';
import { Env } from '../Env';
import { assert } from './assert';
export function formPurchaseBackendUrl(urlPath = '/') {
    const url = new URL(urlPath, Env.PURCHASE_BACKEND_URL);
    if (Env.isProduction()) {
        return url.toString();
    }
    const devGatewayUrl = new URL(urlPath, window.location.href);
    const port = devGatewayUrl.protocol === 'http:'
        ? Env.DEV_PURCHASE_BACKEND_INSECURE_GATEWAY_PORT
        : Env.DEV_PURCHASE_BACKEND_SECURE_GATEWAY_PORT;
    devGatewayUrl.port = `${port}`;
    return devGatewayUrl.toString();
}
export function formPluginUrl(pluginId, urlPath = '/') {
    if (Env.isProduction()) {
        return new URL(urlPath, `https://${pluginId}.streamrtvplugins.com`).toString();
    }
    if (pluginId.startsWith(MOCK_PLUGIN_ID_PREFIX)) {
        return formMockPluginUrl(pluginId, urlPath);
    }
    if (pluginId !== 'chat') {
        throw new Error(`Unknown plugin id: ${pluginId}`);
    }
    const devGatewayUrl = new URL(urlPath, window.location.href);
    const port = devGatewayUrl.protocol === 'http:'
        ? Env.DEV_CHAT_INSECURE_GATEWAY_PORT
        : Env.DEV_CHAT_SECURE_GATEWAY_PORT;
    devGatewayUrl.port = `${port}`;
    return devGatewayUrl.toString();
}
function formMockPluginUrl(pluginId, urlPath = '/') {
    assert(!Env.isProduction(), 'Mock plugins are only available in development');
    const devGatewayUrl = new URL(`/${pluginId}${urlPath}`, window.location.href);
    const port = devGatewayUrl.protocol === 'http:'
        ? Env.DEV_MOCK_PLUGIN_INSECURE_GATEWAY
        : Env.DEV_MOCK_PLUGIN_SECURE_GATEWAY;
    devGatewayUrl.port = port;
    return devGatewayUrl.toString();
}
